/**
 * EVENTSFLO-CREW-PLANNER-DATE-FILTER-SORT-AND-COLUMN-WIDTH-V1
 *
 * Pure-function helpers for the Crew Planner date-range Display filter.
 * Kept in a small module so they can be unit-tested without spinning up React.
 */

export const DISPLAY_RANGE_VALUES = ["all", "today", "week", "month"];

/**
 * Compute the [start, end) local-calendar range for a display filter.
 * Returns { start, end } or null for "all".
 *
 * "week" starts on Monday (ISO-ish; locale-agnostic feel).
 */
export function computeDisplayRange(displayRange, now = new Date()) {
  if (!displayRange || displayRange === "all") return null;
  if (displayRange === "today") {
    const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    return { start, end };
  }
  if (displayRange === "week") {
    const dow = (now.getDay() + 6) % 7; // Monday = 0
    const start = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() - dow,
    );
    const end = new Date(start);
    end.setDate(start.getDate() + 7);
    return { start, end };
  }
  if (displayRange === "month") {
    const start = new Date(now.getFullYear(), now.getMonth(), 1);
    const end = new Date(now.getFullYear(), now.getMonth() + 1, 1);
    return { start, end };
  }
  return null;
}

/**
 * Filter a list of shifts by the display range. Shifts without a valid `date`
 * are excluded when a specific range is active (they cannot be placed on a
 * calendar), but always included when displayRange is "all".
 */
export function filterShiftsByDisplayRange(shifts, displayRange, now = new Date()) {
  if (!displayRange || displayRange === "all") return shifts.slice();
  const range = computeDisplayRange(displayRange, now);
  if (!range) return shifts.slice();
  return shifts.filter((shift) => {
    if (!shift || !shift.date) return false;
    const d = new Date(shift.date);
    if (Number.isNaN(d.getTime())) return false;
    return d >= range.start && d < range.end;
  });
}
